import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const ChartMogulModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  overflow: hidden;
  background: ${colors.white};
  border-radius: 16px;
  padding: 48px;
  gap: 32px;
  width: 100%;
  max-width: 524px;

  .close-button {
    position: absolute;
    top: 24px;
    right: 24px;
  }
`;
